import React, { Component } from 'react';
import { connect } from "react-redux"
import Server from '../Server.js'
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ProgressBar } from 'primereact/progressbar';

import Header from '../Header.js'
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { DataView } from 'primereact/dataview';
import DatePicker from 'react-datepicker2';
import { Dialog } from 'primereact/dialog';
import axios from 'axios'
import {  Route, Link, Navigate } from 'react-router-dom'

class SetDeposit extends React.Component {
    constructor(props) {
        super(props);
        this.Server = new Server();
        this.toast = React.createRef();
        this.FileUpload = this.FileUpload.bind(this);

        this.state = {
            edit: window.location.href.split("edit=")[1],
            basic: true,
            ButtonText: "ثبت درخواست",
            listViewData: [],
            Accounts: [],
            ChequeNember: 0,
            step: 1,
            help: true,
            disableForm: false,
            ShowLoading: false,
            CodeFile: [],
            absoluteUrl: this.Server.getAbsoluteUrl(),
            url: this.Server.getUrl(),
            url2: this.Server.getUrl(1),
            System: this.Server.getSystem(),
        };
    }

    getCodes(id) {
        let that = this;
        that.setState({
          loading: 1
        })
        let SCallBack = function (response) {
          that.setState({
            CodeFile: response.data.result,
            loading: 0
          })
          that.GetMaps();
        };
        let ECallBack = function (error) {
          that.setState({
            loading: 0
          })
          console.log(error)
        }
        this.Server.send("AdminApi/GetCodes", { id: id }, SCallBack, ECallBack)
      }
    getAppData(){
        let that= this;
        let SCallBack = function (response) {
          const appData = response.data.result[0]||{};
          that.setState({
            appData:appData,
            ShowLoading: false
          })
          that.getCodes("18");
        };
        let ECallBack = function (error) {
        }
        this.Server.send("MainApi/getAppData", {}, SCallBack, ECallBack)
      }

    ConvertNumToFarsi(text) {
        if (!text)
            return text;
        var id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        return text.toString().replace(/[0-9]/g, function (w) {
            return id[+w]
        });
    }
    componentDidMount() {
        this.getAppData();
        axios.post(this.state.url + 'checktoken', {
            token: localStorage.getItem("api_token")
        })
            .then(response => {
                this.setState({
                    UId: response.data.authData.userId
                })
            })
            .catch(error => {

            })

    }
    
    SetFish() {
        let that = this;
        if (!this.state.CodeMelli) {
            that.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium"></div>, detail: <div className="iranyekanwebmedium">کد ملی / شماره حساب صندوق را وارد کنید</div>, life: 4000 });

            return
        }
        if (!this.state.Amount) {
            that.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium"></div>, detail: <div className="iranyekanwebmedium">شماره شناسنامه را وارد کنید</div>, life: 4000 });

            return
        }
        
        if (!this.state.mobile) {
            that.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium"></div>, detail: <div><div className="iranyekanwebmedium">موبایل را وارد کنید</div></div>, life: 4000 });

            return
        }
        if (!this.state.Fish_Pic) {
            that.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium"></div>, detail: <div className="iranyekanwebmedium"> تصویر فیش را آپلود کنید</div>, life: 4000 });

            return
        }
       
        that.setState({
            loading: 1,
            disableForm: true
        })
        let param = {
            token: localStorage.getItem("api_token"),
            CodeMelli: this.state.CodeMelli,
            Amount: this.state.Amount.toString().replace(/,/g, ""),
            mobile: this.state.mobile,
            FishDate: this.state.FishDate.local("fa").format("jYYYY/jM/jD"),
            name: this.state.name,
            fishBank: this.state.fishBank,
            Fish_Pic: this.state.Fish_Pic,
            systemId:  this.state.System ?  this.state.System.id : null

        };
        let SCallBack = function (response) {
            that.setState({
                loading: 0
            })
            if(response.data.err){
                that.toast.current.show({ severity: 'error', summary: <div className="iranyekanwebmedium"></div>, detail: <div className="iranyekanwebmedium">{response.data.err}</div>, life: 4000 });
                that.setState({
                    loading: 0,
                    disableForm: false
                })
                return;
            }
            
            that.toast.current.show({ severity: 'success', summary: <div className="iranyekanwebmedium"></div>, detail: <div className="iranyekanwebmedium">عملیات با موفقیت انجام شد</div>, life: 4000 });

            setTimeout(()=>{
                that.setState({
                    disableForm:false
                })
            },2000)
        };
        let ECallBack = function (error) {
            that.setState({
                loading: 0,
                disableForm: false
            })
            that.toast.current.show({ severity: 'error', summary: <div className="iranyekanwebmedium"></div>, detail: <div className="iranyekanwebmedium">عملیات انجام نشد</div>, life: 4000 });

            console.log(error)
        }
        this.Server.send("AdminApi/SetFish", param, SCallBack, ECallBack)


    }

    FileUpload(e) {
        e.preventDefault();
        const formData = new FormData();
        let name = e.target.name;
        formData.append('myImage', e.target.files[0]);
        formData.append('ExtraFile', 1);

        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const { loaded, total } = progressEvent;
                let percent = parseInt((loaded * 100) / total)
                this.setState({
                    showLoadedCount: 1,
                    disableForm: true,
                    loadedCount: percent
                })
                if (percent == "100") {
                    this.setState({
                        disableForm: false,
                        showLoadedCount: 0
                    })
                }

            }
        };
        axios.post(this.state.url2 + 'uploadFile', formData, config)
            .then((response) => {
                this.setState({
                    help: false,
                    [name]: this.state.absoluteUrl + response.data.split("public")[1]
                })
            })
            .catch((error) => {
                console.log(error);
            });
    }
    render() {

        return (
            !this.state.ShowLoading ?
                <div>
                    {this.state.appData &&
                        <Header ComponentName="ثبت واریزی" appDataParam={this.state.appData}  />
                    }
                    <Toast ref={this.toast} position="top-right" style={{ fontFamily: 'iranyekanwebmedium', textAlign: 'right' }} />
                    <div style={{ display: 'flex', height: '100%', justifyContent: 'space-between', flexDirection: 'column', padding: 8 }} >
                        {this.state.showLoadedCount > 0 &&
                            <ProgressBar value={this.state.loadedCount} />
                        }
                        {this.state.step == 2 &&

                            <div style={{ textAlign: 'right', marginTop: 15 }}>
                                <Button className="p-button-info iranyekanwebmedium" onClick={() => this.setState({ step: 1 })} >
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                                        <i className="fas fa-forward" />
                                    </div>


                                </Button>

                            </div>
                        }
                        <div>
                            <p style={{ fontFamily: 'iranyekanwebmedium', textAlign: 'center', fontSize: 13 }}>لطفا برای ثبت اطلاعات واریزی موارد زیر را به طور کامل تکمیل کنید</p>
                            
                        </div>


                            <div style={{ textAlign: 'right', marginTop: 15 }}>
                                <label style={{ textAlign: "center", fontFamily: 'iranyekanwebmedium', width: '100%', fontSize: 13 }}>نام و نام خانوادگی</label>

                                <InputText autocomplete="off" disabled={this.state.disableForm} value={this.state.name} keyboardType="default" placeholder="" name="name" onChange={(text) => {
                                    this.setState({
                                        name: text.target.value
                                    })
                                }} style={{ textAlign: "center", fontFamily: 'iranyekanwebmedium', width: '100%' }} />

                            </div>

                            <div style={{ textAlign: 'right', marginTop: 15 }}>
                                <label style={{ textAlign: "center", fontFamily: 'iranyekanwebmedium', width: '100%', fontSize: 13 }}>کد ملی / شماره حساب صندوق</label>
                                <InputText autocomplete="off" disabled={this.state.disableForm} value={this.state.CodeMelli} keyboardType="default" name="CodeMelli" onChange={(text) => {
                                    this.setState({
                                        CodeMelli: text.target.value
                                    })
                                }} style={{ textAlign: "center", fontFamily: 'iranyekanwebmedium', width: '100%' }} />

                            </div>

                            <div style={{ textAlign: 'right', marginTop: 15 }}>
                                <label style={{ textAlign: "center", fontFamily: 'iranyekanwebmedium', width: '100%', fontSize: 13 }}>تلفن همراه</label>

                                <InputText autocomplete="off" disabled={this.state.disableForm} value={this.state.mobile} keyboardType="default" placeholder="" name="mobile" onChange={(text) => {
                                    this.setState({
                                        mobile: text.target.value
                                    })
                                }} style={{ textAlign: "center", fontFamily: 'iranyekanwebmedium', width: '100%' }} />

                            </div>
                            <div style={{ textAlign: 'right', marginTop: 15 }}>
                                <label style={{ textAlign: "center", fontFamily: 'iranyekanwebmedium', width: '100%', fontSize: 13 }}>مبلغ فیش (ریال)</label>
                                <InputText autocomplete="off" disabled={this.state.disableForm} value={this.state.Amount} keyboardType="default" name="Amount" onChange={(text) => {
                                    this.setState({
                                        Amount: text.target.value.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    })
                                }} style={{ textAlign: "center", fontFamily: 'iranyekanwebmedium', width: '100%' }} />

                            </div>
                            <div style={{ textAlign: 'right', marginTop: 15, width: '100%' }} className="DatePicker">
                                <label style={{ textAlign: "center", fontFamily: 'iranyekanwebmedium', width: '100%', fontSize: 13 }}>تاریخ واریز</label>

                                <DatePicker
                                    inputReadOnly={true}
                                    onChange={value => this.setState({ FishDate: value })}
                                    value={this.state.FishDate}
                                    style={{ textAlign: "right", fontFamily: 'iranyekanwebmedium', width: '100%', marginTop: 15 }}
                                    isGregorian={false}
                                    timePicker={false}
                                    placeholder=""
                                    persianDigits={false}
                                    disabled={this.state.disableForm}
                                />
                            </div>
                            {this.state.CodeFile.map((v, i) => {
                            return (
                            <div style={{ textAlign: 'right', marginTop: 15, width: '100%' }}>
                                
                                <div style={{display:'flex',flexDirection:'column'}}>
                                <label style={{ textAlign: "right", fontFamily: 'iranyekanwebmedium', width: '100%', fontSize: 13 }}>{v.title}</label>
                                    <select className="custom-select irsans" style={{height:35,textAlign:'right'}} value={this.state.fishBank} onChange={(event) => { this.setState({ fishBank: event.target.value }) }} >
                                    <option value=""></option>
                                    {
                                        v.values.map(function (u, j) {
                                        return (
                                            <option value={u.value}>{u.desc}</option>
                                        )
                                        })


                                    }
                                    </select>
                                </div>
                            </div>
                            )
                        })}
                         
                        
                            <div style={{ textAlign: 'right', marginTop: 15 }}>

                                <label style={{ textAlign: "center", fontFamily: 'iranyekanwebmedium', width: '100%', fontSize: 13 }}>آپلود تصویر فیش</label>
                                <InputText autocomplete="off" disabled={this.state.disableForm} style={{ textAlign: "center", fontFamily: 'iranyekanwebmedium', width: '100%' }} className="form-control IRANYekan" keyboardType="default" placeholder="" autoComplete="off" onChange={this.FileUpload} type="file" id="Fish_Pic" name="Fish_Pic" />


                            </div>
                            {this.state.Fish_Pic &&

                                    <div style={{ textAlign: 'right', marginTop: 15 }}>

                                        <img src={this.state.Fish_Pic} style={{ width: 200 }} />

                                    </div>
                            }


                        <div style={{ textAlign: 'center' }}>
                                <Button disabled={this.state.disableForm} className="p-button-secondary iranyekanwebmedium" style={{ marginTop: 50, padding: 12 }}>
                                    <span className="iranyekanwebmedium" style={{ width: '100%', fontSize: 17, fontFamily: 'iranyekanwebmedium' }} onClick={() => this.SetFish()} >ثبت درخواست</span>
                                </Button>
                            

                        </div>
                    </div>

                </div>
                :
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>




        );
    }
}
function mapStateToProps(state) {
    return {
        username: state.username,
        password: state.password,
        ip: state.ip,
        account: state.account,
        place: state.place,
        fullname: state.fullname,
        tokenrb: state.tokenrb,
        mobile: state.mobile,
        appData:state.appData,
        creditPrice:state.creditPrice,
        systemId:state.systemId
    }
}
export default connect(mapStateToProps)(SetDeposit)  
